'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import MobileComments from '@/app/[locale]/(worlds)/[roomId]/components/MobileComments';
import MobileContentDetailBannerAd from '@/app/[locale]/(worlds)/[roomId]/components/MobileContentDetailBannerAd';
import MobileTrailerMediaSection from '@/app/[locale]/(worlds)/[roomId]/components/MobileTrailerMediaSection';
import PremiumTag from '@/app/[locale]/(worlds)/[roomId]/components/PremiumTag';
import RecommendColumnAdSlot from '@/app/[locale]/(worlds)/[roomId]/components/RecommendColumnAdSlot';
import { VideoProcessingWarning } from '@/app/[locale]/(worlds)/[roomId]/components/VideoProcessingStatus';
import World from '@/app/[locale]/(worlds)/[roomId]/components/World';
import WorldInfoCreator from '@/app/[locale]/(worlds)/[roomId]/components/WorldInfoCreator';
import WorldInfoDetails from '@/app/[locale]/(worlds)/[roomId]/components/WorldInfoDetails';
import WorldLabels from '@/app/[locale]/(worlds)/[roomId]/components/WorldLabels';
import WorldMobileTitleArea from '@/app/[locale]/(worlds)/[roomId]/components/WorldMobileTitleArea';
import WorldPlayIconOverlay from '@/app/[locale]/(worlds)/[roomId]/components/WorldPlayIconOverlay';
import WorldThankYouDialog from '@/app/[locale]/(worlds)/[roomId]/components/WorldThankYouDialog';
import { Separator } from '@/components/ui/separator';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useUAContext } from '@/context/UAContext';
import { useWorldDetailsContext } from '@/context/WorldDetailsContext';
import { useMobilePlayMediaLink } from '@/hooks/useMobilePlayMediaLink';
import { useScrollLock } from '@/hooks/useScrollLock';
import { cn } from '@/lib/utils';
type WorldContentDetailMobileProps = {
  recommendations: ReactNode;
};
function WorldContentDetailMobile(t0) {
  const $ = _c(33);
  const {
    recommendations
  } = t0;
  const {
    isIosMobileApp,
    isMobileLandscape
  } = useUAContext();
  const {
    setScrollLock
  } = useScrollLock();
  const {
    isPremiumRoom
  } = useCheckEnterRoomContext();
  const {
    is3DCommerce
  } = useWorldDetailsContext();
  const isIconOnly = useMobilePlayMediaLink()?.isIconOnly ?? false;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <VideoProcessingWarning />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      backgroundPlay: true,
      containerClassName: "[&_video]:!object-cover [&_video]:!h-full"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== setScrollLock) {
    t3 = <World className="aspect-390/336 md:aspect-768/396 landscape:aspect-auto landscape:h-[300px]" setScrollLock={setScrollLock} video={t2} />;
    $[2] = setScrollLock;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <WorldPlayIconOverlay />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="relative">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <WorldThankYouDialog />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isIconOnly && "empty:hidden";
  let t8;
  if ($[8] !== t7) {
    t8 = cn("flex gap-2", t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== isIosMobileApp || $[11] !== isPremiumRoom) {
    t9 = isPremiumRoom && !isIosMobileApp && <PremiumTag className="border-vive-primary-70 border-[1.5px] bg-transparent" />;
    $[10] = isIosMobileApp;
    $[11] = isPremiumRoom;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== is3DCommerce) {
    t10 = is3DCommerce && <WorldLabels />;
    $[13] = is3DCommerce;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8 || $[17] !== t9) {
    t11 = <div className={t8}>{t9}{t10}</div>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isMobileLandscape) {
    t12 = !isMobileLandscape && <WorldMobileTitleArea />;
    $[19] = isMobileLandscape;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <div className="hidden flex-col gap-4 px-4 has-[>*]:flex landscape:px-[94px]">{t11}{t12}</div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== isMobileLandscape) {
    t14 = !isMobileLandscape && <MobileContentDetailBannerAd />;
    $[24] = isMobileLandscape;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <RecommendColumnAdSlot type="mobile" />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="flex flex-col gap-4 overflow-x-hidden px-4 pb-2 md:px-0 landscape:px-[94px]"><Separator className="bg-vive-surface-normal" /><WorldInfoCreator /><Separator className="bg-vive-surface-normal" /><WorldInfoDetails /><Separator className="bg-vive-surface-normal" /><MobileComments /><MobileTrailerMediaSection /></div>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== recommendations || $[29] !== t13 || $[30] !== t14 || $[31] !== t5) {
    t17 = <div data-section="world-content-mobile" className="flex w-full flex-col gap-4">{t1}{t5}{t6}{t13}{t14}{recommendations}{t15}{t16}</div>;
    $[28] = recommendations;
    $[29] = t13;
    $[30] = t14;
    $[31] = t5;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}
export default WorldContentDetailMobile;